import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
export function ComparisonTable() {
  const badPoints = [{
    emoji: '❌',
    title: 'Mezclar mal la resina',
    desc: 'Proporciones incorrectas.'
  }, {
    emoji: '🫧',
    title: 'No eliminar las burbujas',
    desc: 'Acabado poco profesional.'
  }, {
    emoji: '🌡️',
    title: 'Ignorar la temperatura',
    desc: 'Grietas y deformaciones.'
  }, {
    emoji: '⏳',
    title: 'No respetar el curado',
    desc: 'Pieza arruinada.'
  }, {
    emoji: '💸',
    title: 'Comprar sin conocimiento',
    desc: 'Pérdida de dinero.'
  }, {
    emoji: '🪵',
    title: 'No sellar la madera',
    desc: 'Mayor desperdicio de resina.'
  }];
  const goodPoints = [{
    emoji: '✨',
    title: 'Acabados de nivel profesional',
    desc: 'Resultados que impresionan.'
  }, {
    emoji: '💰',
    title: 'Convertí tu hobby en ingresos',
    desc: 'Creá piezas para vender.'
  }, {
    emoji: '🚀',
    title: 'Aprendé paso a paso',
    desc: 'Sin perder tiempo.'
  }, {
    emoji: '🎯',
    title: 'Dominá la resina epóxica',
    desc: 'Como un profesional.'
  }, {
    emoji: '💎',
    title: 'Piezas con efecto premium',
    desc: 'Brillo y calidad.'
  }, {
    emoji: '🛠️',
    title: 'Técnicas que sí funcionan',
    desc: 'Aplicadas en proyectos reales.'
  }, {
    emoji: '🌊',
    title: 'Diseños únicos y modernos',
    desc: 'Que llaman la atención.'
  }];
  return <section className="py-12 px-4 relative z-10 bg-[#fdf8f3] pt-[0px] pb-[0px] space-y-[0px]" data-id="element-73" data-mp="36lkzm2pns58u">
      <div className="max-w-6xl mx-auto" data-id="element-74" data-mp="31njhbk0249yf">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white border border-gray-200 rounded-2xl p-8 md:p-10 shadow-sm pt-[0px] pb-[0px]" data-id="element-75" data-mp="3gka7r3rr6bbw">
          <div className="mb-8 border-b border-gray-100 pb-6 relative z-10" data-id="element-76" data-mp="3iovyihhq7g7f">
            <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-red-500/10 text-red-600 text-xs font-bold mb-3" data-id="element-77" data-mp="3nngrpwyk8zmd">
              <XIcon className="w-3 h-3" data-id="element-78" data-mp="3sliil428a38e" /> EL ERROR
            </div>
            <h3 className="text-2xl font-bold text-gray-800" data-id="element-79" data-mp="17m9k0g54cos">
              Principiante sin guía
            </h3>
            <p className="text-gray-500 mt-2 text-sm" data-id="element-80" data-mp="67qqfrkyn9fj">
              Arruina piezas y desperdicia resina
            </p>
          </div>
          <ul className="space-y-5" data-id="element-81" data-mp="a6zjsvc395ak">
            {badPoints.map((point, i) => <li key={i} className="flex items-start gap-4 text-gray-600" data-id="element-82" data-mp="f7dukl52qtca" data-mpi={i}>
                <motion.div animate={{
              scale: [1, 1.2, 1]
            }} transition={{
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut',
              delay: i * 0.3
            }} className="bg-red-500/10 p-1.5 rounded-lg shrink-0 mt-0.5 flex items-center justify-center w-8 h-8" data-id="element-83" data-mp="k6i2l8g9il11">
                  <span className="text-sm" data-id="element-84" data-mp="2eec3u4hnc0wj">{point.emoji}</span>
                </motion.div>
                <div className="flex flex-col" data-id="element-85" data-mp="29nvryoth4nca">
                  <span className="font-bold text-gray-800" data-id="element-86" data-mp="29n3v7ao54jkf">{point.title}</span>
                  <span className="text-sm text-gray-500" data-id="element-87" data-mp="24nznkogv6tw7">{point.desc}</span>
                </div>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="bg-white border border-[#d97706]/30 rounded-2xl p-8 md:p-10 relative overflow-hidden shadow-[0_8px_30px_rgba(217,119,6,0.05)]" data-id="element-88" data-mp="1znled33j1dwl">
          {/* Glow effect */}
          <div className="absolute -top-24 -right-24 w-48 h-48 bg-[#d97706]/10 rounded-full blur-3xl" data-id="element-89" data-mp="1c1ewlp4awjt6" />

          <div className="mb-8 border-b border-gray-100 pb-6 relative z-10" data-id="element-90" data-mp="1734z37v3t74e">
            <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-[#d97706]/10 text-[#d97706] text-xs font-bold mb-3" data-id="element-91" data-mp="2vug3mlfk5dig">
              <CheckIcon className="w-3 h-3" data-id="element-92" data-mp="2lx1xbencm53v" /> EL OBJETIVO
            </div>
            <h3 className="text-2xl font-bold text-gray-900" data-id="element-93" data-mp="2lyv2epibch9r">
              Maestro de la Resina
            </h3>
            <p className="text-gray-600 mt-2 text-sm" data-id="element-94" data-mp="2qtsbfwfleqmn">
              Crea piezas de lujo que impactan
            </p>
          </div>
          <ul className="space-y-5 relative z-10" data-id="element-95" data-mp="3jlbzpur1quvi">
            {goodPoints.map((point, i) => <li key={i} className="flex items-start gap-4 text-gray-800 font-medium" data-id="element-96" data-mp="34o1gfz85wkp8" data-mpi={i}>
                <motion.div animate={{
              scale: [1, 1.2, 1]
            }} transition={{
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut',
              delay: i * 0.3
            }} className="bg-[#d97706]/10 p-1.5 rounded-lg shrink-0 mt-0.5 flex items-center justify-center w-8 h-8" data-id="element-97" data-mp="39l1ky5pd5fe8">
                  <span className="text-sm" data-id="element-98" data-mp="pb108vno9mmv">{point.emoji}</span>
                </motion.div>
                <div className="flex flex-col" data-id="element-99" data-mp="l972av4v2wqe">
                  <span className="font-bold text-gray-900" data-id="element-100" data-mp="l9fgqrgmua3p">{point.title}</span>
                  <span className="text-sm text-gray-600" data-id="element-101" data-mp="3tpse0jovo3x7">{point.desc}</span>
                </div>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}